import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { API_BASE_URL } from '../config';
import apiFetch from '../utils/apiFetch';

function PartnerDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch(`${API_BASE_URL}/admin/partner/dashboard`)
      .then((res) => res.json())
      .then((json) => setData(json.data || json))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Layout>
        <div className="text-center py-5">Loading...</div>
      </Layout>
    );
  }

  const cards = [
    { label: 'Total Scans', value: data?.scanCount ?? 0, icon: 'camera', color: '#0d6efd' },
    { label: 'Stores Visited', value: data?.storeCount ?? 0, icon: 'map-pin', color: '#198754' },
    { label: 'Total Earnings', value: `\u00a5${(data?.totalEarnings ?? 0).toLocaleString()}`, icon: 'dollar-sign', color: '#fd7e14' },
  ];

  return (
    <Layout>
      <h4 className="mb-4 fw-bold">Partner Dashboard</h4>

      <div className="row g-3 mb-4">
        {cards.map((card) => (
          <div className="col-md-4" key={card.label}>
            <div className="card h-100">
              <div className="card-body d-flex align-items-center gap-3">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: 48, height: 48, backgroundColor: card.color + '1a' }}
                >
                  <i data-feather={card.icon} style={{ width: 22, height: 22, color: card.color }}></i>
                </div>
                <div>
                  <div style={{ fontSize: '0.75rem', color: '#8a94ad' }}>{card.label}</div>
                  <div className="fw-bold" style={{ fontSize: '1.25rem' }}>{card.value}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {data?.assignments?.length > 0 && (
        <div className="card">
          <div className="card-header fw-semibold" style={{ fontSize: '0.875rem' }}>
            Assigned Areas
          </div>
          <div className="card-body p-0">
            <table className="table table-sm mb-0" style={{ fontSize: '0.8125rem' }}>
              <thead className="table-light">
                <tr>
                  <th>Prefecture</th>
                  <th>Status</th>
                  <th>Target</th>
                  <th>Completed</th>
                  <th>Progress</th>
                </tr>
              </thead>
              <tbody>
                {data.assignments.map((a) => {
                  const pct = a.targetStores > 0 ? Math.round((a.completedStores / a.targetStores) * 100) : 0;
                  return (
                    <tr key={a.id}>
                      <td>{a.prefecture}</td>
                      <td>
                        <span className={`badge bg-${a.status === 'active' ? 'success' : 'secondary'}`}>
                          {a.status}
                        </span>
                      </td>
                      <td>{a.targetStores}</td>
                      <td>{a.completedStores}</td>
                      <td>
                        <div className="progress" style={{ height: 6 }}>
                          <div className="progress-bar" style={{ width: `${pct}%` }}></div>
                        </div>
                        <small className="text-muted">{pct}%</small>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default PartnerDashboard;
